import NavBarHome from "../components/NavBarHome";
import Industries_Frame from "../components/Industries_Frame";
import Testimonial_Frame from "../components/Testimonial_Frame";
import Address_Frame from "../components/Address_Frame";

const AboutUs = () => {
  return (
    <div className="w-full relative bg-white min-h-screen overflow-auto text-left text-11xl text-deepskyblue-200 font-istok-web">
      <NavBarHome
        navBarHomeWidth="1690px"
        navBarHomePosition="absolute"
        navBarHomeTop="50px"
        navBarHomeLeft="113px"
        navBarHomeAlignSelf="unset"
      />

      <div className="">
        <div className="flex flex-col lg:flex-row gap-4 mt-8 px-12">
          <img
            className="object-cover lg:w-1/2 xl:w-1/4"
            alt=""
            src="/presntation-pic@2x.png"
          />

          <div className="mt-4">
            <div className="flex justify-center">
              <b className="text-15xl font-bold uppercase text-deepskyblue-200">
                About us
              </b>
            </div>

            <div className="text-center text-black mt-4 px-4">
              At StaffSurge Consultancy Pvt. Ltd., we are dedicated to providing
              premium recruitment services that help businesses thrive. Since
              our inception, we've built a strong reputation for identifying
              exceptional talent that aligns with the organization's goals. We
              understand that every company is unique, and so are the staffing
              needs, hence we offer tailored solutions that deliver concrete
              results.
            </div>
            <div className="text-center text-black mt-4 px-4">
              Our team of expert recruiters with industry-specific insights,
              innovative techniques, and personalized service provide you with
              highly skilled professionals across various sectors. Whether
              you're looking for temporary, permanent, or executive-level hires,
              we have the expertise to deliver exceptional candidates.
            </div>
          </div>
        </div>

        <div className="px-12">
          <Industries_Frame />
        </div>

        <Address_Frame />
      </div>
    </div>
  );
};

export default AboutUs;
